import React, { useId } from 'react'
import { useForm } from 'react-hook-form'

import { LntModal, LntForm, LntFormItem, LntSelect, LntTextArea } from '@app/components/base'

import { FILTERS_PLACEHOLDERS } from '@app/constants/filters'
import { SIZE } from '@app/constants'
import { COMMENT_SAMPLES } from '@app/constants/queryKeys'

import { getTemplates } from '@app/api/routes/templates'

import { getFilterTemplatesFromEntities } from '@app/utils/entitiesAdapters'

import { AddCommentModalProps } from './types'

interface FormData {
  message?: string
  sampleIds?: number[]
}

export const AddCommentModal: React.FC<AddCommentModalProps> = props => {
  const { onSubmit, onCancel, ...restProps } = props

  const formId = useId()
  const form = useForm<FormData>({
    defaultValues: {
      message: '',
      sampleIds: []
    }
  })

  const handleSubmit = (data: FormData): void => {
    onSubmit({
      message: data.message?.trim() ?? undefined,
      sampleIds: data.sampleIds?.length ? data.sampleIds : undefined
    })
    form.reset()
    if (onCancel) {
      onCancel(null as unknown as React.MouseEvent<HTMLButtonElement>)
    }
  }

  const handleCancel = (e?: React.MouseEvent<HTMLButtonElement>): void => {
    form.reset()
    if (onCancel) {
      onCancel(e ?? (null as unknown as React.MouseEvent<HTMLButtonElement>))
    }
  }

  return (
    <LntModal
      { ...restProps }
      title='Оставить комментарий'
      onCancel={ handleCancel }
      onOk={ async () => await form.handleSubmit(handleSubmit)() }
      okText='Сохранить'
      cancelText='Отмена'
    >
      <LntForm
        id={ formId }
        formInstance={ form }
        layout='vertical'
        onSubmit={ handleSubmit }
      >
        <LntFormItem
          name='sampleIds'
          label='Комментарий'
        >
          <LntSelect
            mode='multiple'
            showArrow
            placeholder={ FILTERS_PLACEHOLDERS.samples }
            querySelect={ {
              queryKey: [COMMENT_SAMPLES.commentSamplesItems],
              queryFn: getTemplates,
              select: getFilterTemplatesFromEntities
            } }
          />
        </LntFormItem>
        <LntFormItem
          name='message'
          label='Дополнительный комментарий'
        >
          <LntTextArea
            showCount
            maxLength={ 250 }
            size={ SIZE.large }
            placeholder={ FILTERS_PLACEHOLDERS.comment }
          />
        </LntFormItem>
      </LntForm>
    </LntModal>
  )
}
